<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="animated fadeIn vld-parent pb-1" style="height: 100%; background-color: #fcfcfc">
        <b-row>
            <b-col>
                <div style=" padding: 5px 32px 5px;border-bottom: 1px solid gray; ">
                    <b-row>
                        <b-col md="4" style="padding: 7px" class="my-auto">
                            <span style="font-weight: bolder">Kontrolldatum: {{control_date}}</span>
                        </b-col>
                        <b-col>
                          <b-button variant="primary" v-if="canGoBack" v-on:click="goBack" class="px-4 float-right ml-3">Zurück</b-button>

                          <b-dropdown id="dropdown-1" text="Drucken" class="float-right ml-3" variant="primary">
                            <b-dropdown-item :href="hrefControl" target="_blank">Kontrolle</b-dropdown-item>
                            <b-dropdown-item :href="hrefControlImgDetail" target="_blank">Kontrolle + Detailbild</b-dropdown-item>
                            <b-dropdown-item :href="hrefControlTree" target="_blank">Baumstammblatt + Kontrolle</b-dropdown-item>
                            <b-dropdown-item :href="hrefControlTreeImgDetail" target="_blank">Baumstammblatt + Kontrolle + Detailbild</b-dropdown-item>
                        </b-dropdown>
                    </b-col>
                    </b-row>
                </div>
            </b-col>
        </b-row>
        <b-row style="padding-top: 1rem; padding-left: 15px; padding-right: 15px">
            <b-col>
                <md-card>
                    <md-card-header style="border-bottom: 1px solid lightgray;">
                        <span style="color: darkslategrey"><b>Kontrolldaten für Baumnummer: {{tree_number}}</b></span>
                    </md-card-header>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col md="6">
                                <b-row>
                                    <b-col class="my-auto"><span>Startzeit:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="control_start" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Endzeit:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="control_end" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Zustand:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="condition" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Verkehrssicherheit:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="verkehrssicher" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Sicherheitserwartung:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="security_expectation" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Vitalität:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="vitality_status" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Entwicklungsphase:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="growing_state" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-2">
                                    <b-col class="my-auto"><span>Nächste Kontrolle:</span></b-col>
                                    <b-col md="8">
                                        <b-form-input class="black" v-model="next_control" disabled>
                                        </b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col md="6" style="padding-top: 6px">
                                <span style="margin-top: 20px">Notizen des Kontrolleurs:</span>
                                <b-form-textarea style="margin-top: 16px"
                                                 rows="9"
                                                 class="black"
                                                 no-resize
                                                 v-model="note"
                                                 disabled
                                ></b-form-textarea>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>
        <b-row style="padding-top: 0.5rem; padding-left: 15px; padding-right: 15px">
            <b-col>
                <md-card>
                    <md-card-content style="margin-top: 16px">
                        <b-row>
                            <b-col md="6" lg="4">
                                <span style="color: darkslategrey"><b>Status: Krone</b></span>
                                <b-table striped :items="items_1"
                                         :fields="fields_table_1"
                                         style="margin-top: 10px"
                                >
                                    <template v-slot:cell(is_set_u)="row">
                                        <b-form-checkbox
                                                class="unbe"
                                                :checked="!row.item.is_set"
                                                disabled
                                        >
                                        </b-form-checkbox>
                                    </template>
                                    <template v-slot:cell(is_set_g)="row">
                                        <b-form-checkbox
                                                class="gef"
                                                :checked="row.item.is_set"
                                                disabled
                                        >
                                        </b-form-checkbox>
                                    </template>
                                    <template v-slot:cell(note)="row">
                                        <text-icon v-on:click="showText(row.item.note)" v-if="row.item.note !== ''" class="icon-1_5x ml-2 hoverable-icon"
                                                   fillColor="#16aa13" :size="72" style="color: green"></text-icon>
                                    </template>
                                    <template v-slot:cell(image_url)="row">
                                        <image-icon v-if="row.item.image_url !== ''"
                                                    v-on:click="showImage(row.item.image_url)"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"></image-icon>
                                    </template>
                                </b-table>
                            </b-col>
                            <b-col md="6" lg="4">
                                <span style="color: darkslategrey"><b>Status: Stamm</b></span>
                                <b-table striped :items="items_2"
                                         :fields="fields_table_2"
                                         style="margin-top: 10px"

                                >
                                    <template v-slot:cell(is_set_u)="row">
                                        <b-form-checkbox
                                                class="unbe"
                                                :checked="!row.item.is_set"
                                                disabled
                                        >
                                        </b-form-checkbox>
                                    </template>
                                    <template v-slot:cell(is_set_g)="row">
                                        <b-form-checkbox
                                                class="gef"
                                                :checked="row.item.is_set"
                                                disabled
                                        >
                                        </b-form-checkbox>
                                    </template>
                                    <template v-slot:cell(note)="row">
                                        <text-icon v-on:click="showText(row.item.note)" v-if="row.item.note !== ''" class="icon-1_5x ml-2 hoverable-icon"
                                                   fillColor="#16aa13" :size="72" style="color: green"></text-icon>
                                    </template>
                                    <template v-slot:cell(image_url)="row">
                                        <image-icon v-if="row.item.image_url !== ''"
                                                    v-on:click="showImage(row.item.image_url)"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"></image-icon>
                                    </template>
                                </b-table>
                            </b-col>
                            <b-col md="6" lg="4">
                                <span style="color: darkslategrey"><b>Status: Fuß, Umfeld</b></span>
                                <b-table striped :items="items_3"
                                         :fields="fields_table_3"
                                         style="margin-top: 10px"
                                >
                                    <template v-slot:cell(is_set_u)="row">
                                        <b-form-checkbox
                                                class="unbe"
                                                :checked="!row.item.is_set"
                                                disabled
                                        >
                                        </b-form-checkbox>
                                    </template>
                                    <template v-slot:cell(is_set_g)="row">
                                        <b-form-checkbox
                                                class="gef"
                                                :checked="row.item.is_set"
                                                disabled
                                        >
                                        </b-form-checkbox>
                                    </template>
                                    <template v-slot:cell(note)="row">
                                        <text-icon v-on:click="showText(row.item.note)" v-if="row.item.note !== ''" class="icon-1_5x ml-2 hoverable-icon"
                                                   fillColor="#16aa13" :size="72" style="color: green"></text-icon>
                                    </template>
                                    <template v-slot:cell(image_url)="row">
                                        <image-icon v-if="row.item.image_url !== ''"
                                                    v-on:click="showImage(row.item.image_url)"
                                                    class="icon-1_5x ml-2 hoverable-icon" fillColor="#16aa13" :size="72"
                                                    style="color: green"></image-icon>
                                    </template>
                                </b-table>
                            </b-col>
                        </b-row>
                    </md-card-content>
                </md-card>
            </b-col>
        </b-row>
        <CoolLightBox
                :items="images"
                :index="index"
                @close="index = null">
        </CoolLightBox>
        <modal name="text"
               :height="'auto'"
               adaptive>
            <p style="padding-top: 12px; padding-left: 12px; margin-bottom: 0.5rem"><strong>Notiz:</strong></p>
            <p style="padding: 12px">{{text}}</p>
        </modal>
    </div>
</template>

<script>
    import {Server_URL} from "../../shared/utils";
    import ImageIcon from 'vue-material-design-icons/Image.vue';
    import TextIcon from 'vue-material-design-icons/CommentText.vue';
    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        name: "control",
        components: {
            ImageIcon,
            TextIcon,
            CoolLightBox,
        },
        mounted() {
          this.canGoBack = window.history.length > 1;
          this.showLoader();
            this.$http.get(
                Server_URL + '/baumkontrolle/control/'+this.$route.params.id
            ).then(this.responseOkGet, this.responseError)
        },
        data() {
            return {
              canGoBack: false,
              images: [
                    'https://picsum.photos/1024/400/?image=41',
                ],
                index: null,
                text: "",
                loader: undefined,
                fields_table_1: [
                    {key: "name", label: "Status"},
                    {key: "is_set_u", label: "unbedenklich"},
                    {key: "is_set_g", label: "gefährlich"},
                    {key: "note", label: "Notiz"},
                    {key: "image_url", label: "Bild"},
                ],
                fields_table_2: [
                    {key: "name", label: "Status"},
                    {key: "is_set_u", label: "unbedenklich"},
                    {key: "is_set_g", label: "gefährlich"},
                    {key: "note", label: "Notiz"},
                    {key: "image_url", label: "Bild"},
                ],
                fields_table_3: [
                    {key: "name", label: "Status"},
                    {key: "is_set_u", label: "unbedenklich"},
                    {key: "is_set_g", label: "gefährlich"},
                    {key: "note", label: "Notiz"},
                    {key: "image_url", label: "Bild"},
                ],
                items_1: [],
                items_2: [],
                items_3: [],
                condition: "",
                vitality_status: "",
                growing_state: "",
                verkehrssicher: "",
                security_expectation: "",
                note: "",
                next_control: "",
                control_date: "",
                control_id: "",
                tree_number: "",
                tree_id: "",
                control_start: "",
                control_end: ""
            }
        },
        computed: {
            hrefControl: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?control_id='+this.control_id
            },
            hrefControlImgDetail: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?control_id='+this.control_id+ "&image_detail=true"
            },
            hrefControlTree: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?control_id='+this.control_id+"&tree_id="+this.tree_id
            },
            hrefControlTreeImgDetail: function () {
                return Server_URL + '/baumkontrolle/tree/pdf?control_id='+this.control_id+"&tree_id="+this.tree_id+ "&image_detail=true"
            },
        },
        methods: {
          goBack(){
            this.$router.go(-1);
          },
            showImage(image) {
                this.images = [Server_URL + '/baumkontrolle/control_status/image' + "?control_id=" + this.control_id + "&image_name=" + image+"_x2.jpeg"];
                this.index = 0;
            },
            showText(text) {
                this.text = text;
                this.$modal.show('text');
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                console.log(response)
                if (response.status === 200) {
                    this.reset();
                    let stati = response.data.control_stati;
                    for (let i = 0; i < stati.length; i++) {
                        switch (stati[i].status_type) {
                            case "status_top":
                                this.items_1.push(stati[i]);
                                break;
                            case "status_middle":
                                this.items_2.push(stati[i]);
                                break;
                            case "status_bottom":
                                this.items_3.push(stati[i]);
                                break;
                        }
                    }
                    let control = response.body.control;
                    this.control_id = control.id;
                    this.tree_number = control.tree_number;
                    this.tree_id = control.tree_id;
                    for (let i = 0; i < response.body.constants_growing_state.length; i++) {
                        if (control.growing_state === response.body.constants_growing_state[i].id) {
                            this.growing_state = response.body.constants_growing_state[i].text;
                            break;
                        }
                    }
                    if (this.growing_state === "") {
                        this.growing_state = "Nicht gesetzt"
                    }

                    for (let i = 0; i < response.body.constants_condition.length; i++) {
                        if (control.condition === response.body.constants_condition[i].id) {
                            this.condition = response.body.constants_condition[i].text;
                            break;
                        }
                    }
                    if (this.condition === "") {
                        this.condition = "Nicht gesetzt"
                    }

                    for (let i = 0; i < response.body.constants_security_expectation.length; i++) {
                        if (control.security_expectation === response.body.constants_security_expectation[i].id) {
                            this.security_expectation = response.body.constants_security_expectation[i].text;
                            break;
                        }
                    }
                    if (this.security_expectation === "") {
                        this.security_expectation = "Nicht gesetzt"
                    }
                    this.next_control = this.formatDate(control.next_control);
                    this.verkehrssicher = control.verkehrssicher;
                    this.vitality_status = control.vitality_status;
                    this.note = control.note;
                    this.control_date = this.formatDate(control.date);
                    var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: "2-digit", minute: "2-digit"};

                    if (control.control_start !== null) {
                        this.control_start = (new Date(Date.parse(control.control_start))).toLocaleDateString("de-DE", options);
                    }
                    if (control.control_end !== null) {
                        this.control_end = (new Date(Date.parse(control.control_end))).toLocaleDateString("de-DE", options);
                    }
                } else {
                    console.log(response);
                }
            },
            reset() {
                this.items_1 = [];
                this.items_2 = [];
                this.items_3 = [];
                this.condition = "";
                this.vitality_status = "";
                this.growing_state = "";
                this.verkehrssicher = "";
                this.security_expectation = "";
                this.note = "";
                this.next_control = "";
                this.control_date = "";
                this.control_id = "";
            },
            formatDate(date) {
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [day, month, year].join('.');
            }
        }
    }
</script>
<style>
    .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: rgb(66, 139, 202);
    }

    .unbe .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: green !important;
    }

    .gef .custom-control-input:disabled:checked ~ .custom-control-label::before {
        background-color: red !important;
    }

    .black {
        color: #000;
    }

    .modal-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .modal-container {
        display: inline-block;
        width: auto;
    }
</style>
<style scoped>

    .hoverable:hover {
        color: #23282c;
        background-color: rgba(0, 0, 0, 0.075);
        cursor: pointer;
    }

    .hoverable-icon:hover {
        cursor: pointer;
    }
</style>
